import { CandidateInfo } from './candidateInfo';
export class Post {
  public body: string = '';
  public canBeDeleted: boolean = true;
  public canBeEdited: boolean = true;
  public candidateInfo: CandidateInfo = new CandidateInfo();
  public closedDTTM: null = null;
  public commentCount: number = 0;
  public unreportedCommentCount: number = 0;
  public companyCode: string = '';
  public createdDTTM: string = '';
  public fileGUIDs: null = null;
  public hasLiked: boolean = false;
  public postId: number = 0;
  public postStatus: number = 1;
  public reportedCount: number = 0;
  public title: string = '';
  public topicId: number = 0;
  public topicName: null = null;
  public upCount: number = 0;
  public updatedDTTM: null = null;
  public viewCount: null = null;
  
}
